import React from "react";

import ReactHelmet from "../../components/react-helmet/react-helmet";
const Ohioheader = () => {
  return (
    <>
      <ReactHelmet
        title={"Facilities For Sober Living in Ohio | Taste Recovery"}
        description={
          "Browse available facilities for sober living in Ohio offering safe, peer-reviewed & supportive environments to help individuals maintain lasting recovery."
        }
      />
    </>
  );
};

export default Ohioheader;
